module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('span', {
    staticClass: "font1"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06chapter01#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("QUICK-PICKLED"), _c('br'), _vm._v("VEGGIES")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06chapter01#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07chapter02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MARINATED"), _c('br'), _vm._v("OLIVES")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07chapter02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUMMER VEGETABLE"), _c('br'), _vm._v("GUACAMOLE SALSA")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CURRIED"), _c('br'), _vm._v("DEVILED EGGS")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("QUICK"), _c('br'), _vm._v("SUMMERTIME"), _c('br'), _vm._v("GAZPACHO")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GREEN BEAN, BELL"), _c('br'), _vm._v("PEPPER, JICAMA,"), _c('br'), _vm._v("AND TOMATO SALAD")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHILLED"), _c('br'), _vm._v("ASPARAGUS")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GRILLED"), _c('br'), _vm._v("CORN")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GRILLED"), _c('br'), _vm._v("SWEET POTATOES")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GRILLED"), _c('br'), _vm._v("PIZZA")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GRILLED"), _c('br'), _vm._v("TEQUILA-LIME"), _c('br'), _vm._v("SHRIMP")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GRILLED"), _c('br'), _vm._v("SNAPPER TACOS")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/18chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GRILLED"), _c('br'), _vm._v("STRIPED BASS")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GRILLED"), _c('br'), _vm._v("SALMON")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GRILLED"), _c('br'), _vm._v("CHICKEN")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HONEY-GLAZED"), _c('br'), _vm._v("SPARERIBS")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("41")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GRILLED"), _c('br'), _vm._v("LAMB CHOPS"), _c('br'), _c('span', {
    staticClass: "display_type"
  }, [_vm._v("WITH CILANTRO-MINT"), _c('br'), _vm._v("SAUCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FOOLPROOF"), _c('br'), _vm._v("BURGERS")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("47")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NECTARINE"), _c('br'), _vm._v("TART")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENGLISH BERRY"), _c('br'), _vm._v("SUMMER PUDDING")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HONEY-GINGER"), _c('br'), _vm._v("LEMONADE")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WATERMELON-LIME"), _c('br'), _vm._v("AGUA FRESCA")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("57")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28chapter23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PRICKLY"), _c('br'), _vm._v("AGAVE")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28chapter23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("59")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29chapter24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SOUTH SEAS"), _c('br'), _vm._v("SANGRIA")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29chapter24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30chapter25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MOJITOS")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30chapter25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("63")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa2c9a96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05toc.vue
// module id = 69
// module chunks = 0